/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { withRouter, Link, useHistory, useLocation, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
// images
import { useDispatch, useSelector } from "react-redux";
import { Button, Tabs, Accordion, Tab, Container, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import superagent from "superagent";
import Cookies from "universal-cookie";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { isTablet } from "react-device-detect";
import menuBg from "../../assets/images/bg/menu/home.svg";
import FooterBottom from "../../components/footerBottom";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import Loader from "../../components/loader";
import MemberImage from "../../assets/images/member_banner.png";
import TabImage from "../../assets/images/program_tour_3.png";
import logo from "../../assets/images/logo.png";
import { checkEmptyObject, scrollToElementById } from "../../utils/commonFunctions";
import SignupModal from "../../components/signupModal";
import PremiumModal from "../../components/premiumModal";
import ProModal from "../../components/ProModal";
import { base_url } from "../../utils/constants";
import PlanToBasicModel from "./planToBasicModel";
import "swiper/swiper-bundle.min.css";
import "./style.scss";
import { useApplyCoupon } from "./useApplyCoupon";
import useBeforMount from "../../hooks/useBeforMount";
import { premium_month, premium_year, pro_month, pro_year } from "./constants";
import { getMemberBenefitsCMSData, getMemberBenefitsHeroCMSData } from "../admin/dashboard/actions";
import HeroSection from "./heroSection/HeroSection";
import CustomButton from "../../components/Buttons/CustomButton";
import FAQSection from "../FaqSection/FAQSection";
import MetaTags from "../../components/metas";
import useMobile from "../../hooks/useMobile";

const cookie = new Cookies();
const classes = {
  checkedClass: "fa-solid fa-check h6 text-success",
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function Membership() {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const freeTrialUpgradeToPro = query.get("type");
  const freeTrialUserId = query.get("user_id");
  const scrollTo = query.get("scrollto");
  const isMobile = useMobile();

  const [openMenu, setOpenMenu] = useState(false);
  const [freeTrialProModal, setFreeTrialProModal] = useState(false);
  const [keyword] = useState("");
  const [monthly, setMonthly] = useState(false);
  const [monthlyPremium, setMonthlyPremium] = useState(false);
  const [monthlyPro, setMonthlyPro] = useState(false);

  const [isModal, setIsModal] = useState(false);
  const [premiumUpgradeModal, setPremiumUpgradeModal] = useState(false);
  const [premiumMonthUpgradeModal, setPremiumMonthUpgradeModal] = useState(false);
  const [proUpgradeModal, setProUpgradeModal] = useState(false);
  const [proMonthUpgradeModal, setProMonthUpgradeModal] = useState(false);

  const [basic1Model, setBasic1Modal] = useState(false);
  const planSectionRef = useRef(null);
  const tabSectionRef = useRef(null);
  const isLoading = useSelector((state) => state?.meta?.isLoading);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { key } = useParams();
  const data = useSelector((state) => state?.admin?.membership_cms);
  const userInfo = useSelector((state) => state?.my_account?.user_info);
  const myAccountUrl = "/my-account";
  const acceptHeader = "application/json";

  const couponParam = query.get("coupon");
  const planParam = query.get("plan");

  useBeforMount(() => {
    if ((planParam || couponParam) && !userInfo?.auth_token) {
      console.log("user_info", "Not Logged IN!!!", location.pathname);
      const url = `/membership?plan=${planParam}&coupon=${couponParam}`;
      const membershipUrl = encodeURIComponent(url);
      history.push(`/login?coupon_url=${membershipUrl}`);
    }
  });

  useApplyCoupon(planParam, setProMonthUpgradeModal, setProUpgradeModal, setPremiumMonthUpgradeModal, setPremiumUpgradeModal, setMonthlyPro, setMonthlyPremium);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (key) {
      const timeOut = setTimeout(() => {
        if (!isLoading && !checkEmptyObject(data) && key) {
          tabSectionRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 1500);
      return () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        timeOut && clearTimeout(timeOut);
      };
    }
  }, [key, isLoading, data]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (!isLoading && !checkEmptyObject(data) && location?.state === "upgrade") {
        planSectionRef?.current?.scrollIntoView();
        location.state = null;
      }
    }, 1500);
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      timeOut && clearTimeout(timeOut);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (freeTrialUpgradeToPro === "free-trial") {
      if (userInfo?.auth_token) {
        // eslint-disable-next-line eqeqeq
        if ((userInfo?.subscription_type !== "PRO" || userInfo?.type === "trial") && freeTrialUserId == userInfo?.id) {
          setFreeTrialProModal(true);
        }
      } else {
        history.push("/login?membership=membership-popup");
      }
    }
  }, [freeTrialUpgradeToPro, history, userInfo?.auth_token, userInfo?.subscription_type, freeTrialUserId, userInfo?.id, userInfo?.type]);

  useEffect(() => {
    dispatch(getMemberBenefitsHeroCMSData());
    dispatch(getMemberBenefitsCMSData());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleOpenMenu = useCallback(() => {
    setOpenMenu(!openMenu);
  }, [openMenu]);
  const handleCloseMenuMenu = useCallback(() => {
    setOpenMenu(false);
  }, []);

  const handleJoinForFree = useCallback(() => {
    if (cookie.get("user_token")) {
      toast.success("Thank you for being with us. You are already a customer");
    } else {
      window.location = `${data?.hero_button_link || "/signup"}`;
    }
  }, [data?.hero_button_link, history]);
  console.log("userInfo", userInfo);
  const handleSubscription = useCallback(
    (newSubscriptionType) => {
      if (!userInfo || !cookie.get("user_token")) {
        window.location = "/signup";
      } else if (userInfo?.email_verified_at && userInfo?.is_complete === 0) {
        history.push("/account-complete");
      } else if (
        newSubscriptionType === "BASIC" &&
        (userInfo?.subscription_type === "PREMIUM_MONTH" ||
          userInfo?.subscription_type === "PREMIUM" ||
          userInfo?.subscription_type === "PRO_MONTH" ||
          userInfo?.subscription_type === "PRO")
      ) {
        setBasic1Modal(true);
      }
      // subscribe for new user
      else if (newSubscriptionType === "BASIC" && !userInfo?.is_complete) {
        history.push("/account-complete");
      } else if (newSubscriptionType === userInfo?.subscription_type && userInfo?.type !== "trial") {
        window.location.replace(myAccountUrl);
        toast.success(`You are already ${userInfo?.subscription_type} member.`, { autoClose: 4000 });
      } else if (newSubscriptionType === "PREMIUM") {
        setPremiumUpgradeModal(true);
        setMonthlyPremium(false);
      } else if (newSubscriptionType === "PREMIUM_MONTH") {
        setPremiumMonthUpgradeModal(true);
        setMonthlyPremium(true);
      } else if (newSubscriptionType === "PRO") {
        setProUpgradeModal(true);
        setMonthlyPro(false);
      } else if (newSubscriptionType === "PRO_MONTH") {
        setProMonthUpgradeModal(true);
        setMonthlyPro(true);
      } else {
        history.push("/membership");
      }
    },
    [history, userInfo],
  );

  const subscribeToPremium = useCallback(() => {
    if (userInfo?.subscription_type === "BASIC") {
      superagent
        .get(`${base_url}subscription/PREMIUM`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          window.location = res.body.url;
        });
    } else {
      superagent
        .post(`${base_url}update-plan-data?plan=PREMIUM`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          toast.success(res.body.message);
          if (res.body.status === true) {
            window.location.replace(myAccountUrl);
          }
        });
    }
  }, [history, userInfo?.subscription_type]);

  const subscribeToPremiumMonth = useCallback(() => {
    if (userInfo?.subscription_type === "BASIC") {
      superagent
        .get(`${base_url}subscription/PREMIUM_MONTH`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          window.location = res.body.url;
        });
    } else {
      superagent
        .post(`${base_url}update-plan-data?plan=PREMIUM_MONTH`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          toast.success(res.body.message);
          if (res.body.status === true) {
            window.location.replace(myAccountUrl);
          }
        });
    }
  }, [history, userInfo?.subscription_type]);

  const subscribeToPro = useCallback(() => {
    if (userInfo?.subscription_type === "BASIC") {
      superagent
        .get(`${base_url}subscription/PRO`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          window.location = res.body.url;
        });
    } else {
      superagent
        .post(`${base_url}update-plan-data?plan=PRO`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          toast.success(res.body.message);
          if (res.body.status === true) {
            window.location.replace(myAccountUrl);
          }
        });
    }
  }, [history, userInfo?.subscription_type]);

  const subscribeToProMonth = useCallback(() => {
    if (userInfo?.subscription_type === "BASIC") {
      superagent
        .get(`${base_url}subscription/PRO_MONTH`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          window.location = res.body.url;
        });
    } else {
      superagent
        .post(`${base_url}update-plan-data?plan=PRO_MONTH`)
        .set("accept", acceptHeader)
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          toast.success(res.body.message);
          if (res.body.status === true) {
            window.location.replace(myAccountUrl);
          }
        });
    }
  }, [history, userInfo?.subscription_type]);

  const handleClickTop = () => {
    window.scrollTo(0, 0);
  };

  const plansToggle = useCallback(
    (monthPlan, yearPlan, mobileView = false) => {
      const checkIcon = <i className={!mobileView ? classes.checkedClass : "text-premium fa-solid fa-check ml-2"} aria-hidden="true" />;
      const timesIcon = <i className={!mobileView ? "fa-solid fa-times h6 text-danger" : "fa-solid fa-xmark text-danger ml-2"} aria-hidden="true" />;
      if (monthly) {
        return monthPlan ? checkIcon : timesIcon;
      }
      return yearPlan ? checkIcon : timesIcon;
    },
    [monthly],
  );
  useEffect(() => {
    if (scrollTo && !isLoading) {
      scrollToElementById(scrollTo);
    }
  }, [scrollTo, isLoading]);

  const memberShipFaqsSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: data?.faqs?.map((faq) => ({
      "@type": "Question",
      name: faq.title,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.paragraph,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <title>Join Clarity Cooperative: Membership Plans for Therapists</title>
        <meta name="title" content={"Join Clarity Cooperative: Membership Plans for Therapists"} />
        <meta name="description" content={data?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={"Join Clarity Cooperative: Membership Plans for Therapists"} />
        <meta property="og:url" content={data?.url} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={data?.excerpt} />
        <meta name="twitter:card" content={data?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={data?.url} />
        <meta name="twitter:title" content={"Join Clarity Cooperative: Membership Plans for Therapists"} />
        <meta name="twitter:description" content={data?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <MetaTags faqSchema={memberShipFaqsSchema} />

      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />

      {isLoading && checkEmptyObject(data) ? (
        <Loader />
      ) : (
        <>
          <section className="section membershipBanner">
            <Container className="memberShipInner">
              <Row className="align-items-center">
                <Col lg={6} xs={12}>
                  <p className="fw-bold mb-4">{data?.name?.toUpperCase() || "MEMBERSHIP"}</p>
                  <h1 className="mb-2">{data?.hero_title || "hero_title"}</h1>
                  <p className="text-xxl mb-5">
                    {data?.hero_sub_title ||
                      `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s`}
                  </p>
                  <Button aria-hidden type="button" variant="primary" onClick={handleJoinForFree}>
                    {data?.hero_button_text || "Join For Free"}
                  </Button>
                </Col>
                <Col lg={6} xs={12}>
                  <img className="img-fluid" src={data?.hero_image || MemberImage} alt="" />
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section clarityPlans" id="subscription">
            <Container className="clarityPlansInner">
              <Row>
                <Col xl={9} lg={10} className="text-white text-center mb-5 pb-md-5 pb-4 mx-auto">
                  <h2 className="mb-3">{data?.plan_title || "Clarity allows you to scale your private practice without complexity and with less burnout"}</h2>
                  <p className="text-xxl" ref={planSectionRef}>
                    {data?.plan_sub_title ||
                      `Whether you’re just dipping your toes in the water out of curiosity, or fully committed to creating your
                dream practice, we have something for you.`}
                  </p>
                </Col>
              </Row>

              {isMobile || isTablet ? (
                <>
                  <p className="text-white text-center">
                    <b>{data?.plan_paragraph_one}</b>
                    <br />
                    {data?.plan_paragraph_two}
                  </p>
                  <div className="d-flex justify-content-center">
                    <ul className="planTabs mb-4 mt-0 d-flex text-center text-nowrap">
                      <li
                        aria-hidden
                        className={`${!monthly ? "active freeTrial fw-bold" : ""} btn`}
                        onClick={() => {
                          setMonthly(false);
                        }}
                      >
                        <a aria-hidden>ANNUAL</a>

                        {monthly ? "" : <span>2 MONTHS FREE</span>}
                      </li>
                      <li
                        aria-hidden
                        className={`${monthly ? "active freeTrial fw-bold" : ""} btn`}
                        onClick={() => {
                          setMonthly(true);
                        }}
                      >
                        <a aria-hidden>Monthly</a>
                      </li>
                    </ul>
                  </div>
                  {monthly ? <p className="text-white fw-400 text-center">{data?.plan_paragraph_three}</p> : ""}
                  <Swiper pagination modules={[Pagination]} className="mySwiper d-flex flex-column-reverse">
                    <SwiperSlide className="slidePro">
                      <div className="p-3 bg-pro text-center">
                        <span>{data?.plans?.pro_popular && <div className="planTag">POPULAR</div>}</span>
                        <h3 className="text-pro mb-0">{data?.plans?.pro_title || "pro_title  "}</h3>
                        <p className="mb-0">{data?.plans?.pro_subtitle || "pro_subtitle  "}</p>
                        <h1 className="text-pro my-1">{monthly ? <span>$19.99</span> : <span>$199.00</span>}</h1>
                        <p className="mb-0">{monthly ? data?.plans?.pro_month_desc : data?.plans?.pro_year_desc}</p>
                      </div>
                      <div className="d-flex justify-content-between border-bottom p-3  border-top">
                        <strong>
                          <Link to="/resources" onClick={handleClickTop}>
                            <u>Downloadable E-Books resources</u>
                          </Link>
                        </strong>
                        <span className="minw-100px">{data?.plans?.resources_desc_pro}</span>
                      </div>
                      {data?.plans?.planData?.map((plan) => {
                        return (
                          <div key={plan?.description} className="d-flex justify-content-between border-bottom p-3">
                            <span>{plan?.description}</span>
                            <span className="minw-100px">{plansToggle(plan?.proMonth, plan?.proYear, isMobile)}</span>
                          </div>
                        );
                      })}
                      <div className="text-center p-3">
                        <CustomButton
                          variant="blue"
                          type="submit"
                          onClick={() => {
                            handleSubscription(monthly ? "PRO_MONTH" : "PRO");
                            handleClickTop();
                          }}
                        >
                          {data?.plans?.pro_button_text || "pro_button_text"}
                        </CustomButton>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slidePremium">
                      <div className="p-3 bg-premium text-center">
                        <span>{data?.plans?.premium_popular && <div className="planTag">POPULAR</div>}</span>
                        <h3 className="text-premium mb-0">{data?.plans?.premium_title || "premium_title"}</h3>
                        <p className="mb-0">{data?.plans?.premium_subtitle || "premium_subtitle"}</p>
                        <h1 className="text-premium my-1">{monthly ? <span>$9.99</span> : <span>$99.00</span>}</h1>
                        <p className="mb-0">{monthly ? data?.plans?.premium_month_desc : data?.plans?.premium_year_desc}</p>
                      </div>
                      <div className="d-flex justify-content-between border-bottom p-3 border-top">
                        <strong>
                          <Link to="/resources" onClick={handleClickTop}>
                            <u>Downloadable E-Books resources</u>
                          </Link>
                        </strong>
                        <span className="minw-100px">{data?.plans?.resources_desc_premium}</span>
                      </div>
                      {data?.plans?.planData?.map((plan, index) => {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <div key={index} className="d-flex justify-content-between border-bottom p-3">
                            <span>{plan?.description}</span>
                            <span className="minw-100px">{plansToggle(plan?.premiumMonth, plan?.premiumYear, isMobile)}</span>
                          </div>
                        );
                      })}
                      <div className="text-center p-3">
                        <Button
                        type="button"
                          variant="success"
                          onClick={() => {
                            handleSubscription(monthly ? "PREMIUM_MONTH" : "PREMIUM");
                            handleClickTop();
                          }}
                        >
                          {data?.plans?.premium_button_text || "premium_button_text"}
                        </Button>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide className="slideBasic">
                      <div className="p-3 bg-basic text-center">
                        <span>{data?.plans?.basic_popular && <div className="planTag">POPULAR</div>}</span>
                        <h3 className="text-basic mb-0">{data?.plans?.basic_title || "basic_title"}</h3>
                        <p className="mb-0">{data?.plans?.basic_subtitle || "basic_subtitle"}</p>
                        <h1 className="text-basic my-1">$0</h1>
                        <p className="mb-0">{monthly ? data?.plans?.basic_month_desc : data?.plans?.basic_year_desc}</p>
                      </div>
                      <div className="d-flex justify-content-between border-bottom p-3 border-top">
                        <strong>
                          <Link to="/resources" onClick={handleClickTop}>
                            <u>Downloadable E-Books resources</u>
                          </Link>
                        </strong>
                        <span className="minw-100px">{data?.plans?.resources_desc_basic}</span>
                      </div>
                      {data?.plans?.planData?.map((plan, index) => {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <div key={index} className="d-flex justify-content-between border-bottom p-3">
                            <span>{plan?.description}</span>
                            <span className="minw-100px">{plansToggle(plan?.basicMonth, plan?.basicYear, isMobile)}</span>
                          </div>
                        );
                      })}
                      <div className="text-center p-3">
                        <Button
                          type="button"
                          variant="primary"
                          onClick={() => {
                            handleSubscription("BASIC");
                            handleClickTop();
                          }}
                        >
                          {data?.plans?.basic_button_text || "basic_button_text"}
                        </Button>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </>
              ) : (
                <div className="table-resoponsive">
                  <table width="100%" cellPadding="0" cellSpacing="0" className="clarityPlansTable">
                    <thead>
                      <tr>
                        <th>
                          <p className="text-white">
                            <span className="fw-bold">{data?.plan_paragraph_one}</span>
                            <br />
                            <span className="fw-normal">{data?.plan_paragraph_two}</span>
                          </p>

                          <ul className="planTabs d-flex text-center fw-bold">
                            <li
                              aria-hidden
                              className={`btn ${!monthly ? "freeTrial active fw-bold" : ""}`}
                              onClick={() => {
                                setMonthly(false);
                              }}
                            >
                              <a aria-hidden>ANNUAL</a>
                              {monthly ? "" : <span className="text-sm">2 MONTHS FREE</span>}
                            </li>
                            <li
                              aria-hidden
                              className={`btn ${monthly ? "freeTrial active fw-bold" : ""}`}
                              onClick={() => {
                                setMonthly(true);
                              }}
                            >
                              <a aria-hidden>Monthly</a>
                            </li>
                          </ul>
                          {monthly ? <p className="text-white fw-400">{data?.plan_paragraph_three}</p> : ""}
                        </th>
                        <th className="text-center basicPoll">
                          {data?.plans?.basic_popular && <div className="planTag">POPULAR</div>}
                          <h3 className="">{data?.plans?.basic_title || "basic_title"}</h3>
                          <p className="text-reset fw-normal d-flex align-items-center justify-content-center" style={{ minHeight: "48px" }}>
                            {data?.plans?.basic_subtitle || "basic_subtitle"}
                          </p>
                          <h2 className="">$0</h2>
                          <p className="text-reset fw-normal">{monthly ? data?.plans?.basic_month_desc : data?.plans?.basic_year_desc}</p>
                        </th>
                        <th className="text-center premiumPoll">
                          {data?.plans?.premium_popular && <div className="planTag">POPULAR</div>}
                          <h3 className="">{data?.plans?.premium_title || "premium_title"}</h3>
                          <p className="text-reset fw-normal d-flex align-items-center justify-content-center" style={{ minHeight: "48px" }}>
                            {data?.plans?.premium_subtitle || "premium_subtitle"}
                          </p>
                          {monthly ? <h2 className="">$9.99</h2> : <h2 className="">$99.00</h2>}
                          <p className="text-reset fw-normal">{monthly ? data?.plans?.premium_month_desc : data?.plans?.premium_year_desc}</p>
                        </th>
                        <th className="text-center proPoll">
                          {data?.plans?.pro_popular && <div className="planTag">POPULAR</div>}
                          <h3 className="">{data?.plans?.pro_title || "pro_title  "}</h3>
                          <p className="text-reset fw-normal d-flex align-items-center justify-content-center" style={{ minHeight: "48px" }}>
                            {data?.plans?.pro_subtitle || "pro_subtitle  "}
                          </p>
                          {monthly ? <h2 className="">$19.99</h2> : <h2 className="">$199.00</h2>}
                          <p className="text-reset fw-normal">{monthly ? data?.plans?.pro_month_desc : data?.plans?.pro_year_desc}</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <Link to="/resources" onClick={handleClickTop}>
                              <u>Downloadable E-Books resources</u>
                            </Link>
                          </strong>
                        </td>
                        <td className="text-center">{data?.plans?.resources_desc_basic}</td>
                        <td className="text-center">{data?.plans?.resources_desc_premium}</td>
                        <td className="text-center">{data?.plans?.resources_desc_pro}</td>
                      </tr>

                      {data?.plans?.planData?.map((plan) => {
                        return (
                          <tr key={plan?.description}>
                            <td>{plan?.description}</td>
                            <td className="text-center">{plansToggle(plan?.basicMonth, plan?.basicYear, isMobile)}</td>
                            <td className="text-center">{plansToggle(plan?.premiumMonth, plan?.premiumYear, isMobile)}</td>
                            <td className="text-center">{plansToggle(plan?.proMonth, plan?.proYear, isMobile)}</td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="border-0">&nbsp;</td>
                        <td className="text-center border-bottom-0">
                          <Button
                            className="text-nowrap"
                            variant="primary"
                            onClick={() => {
                              handleSubscription("BASIC");
                              handleClickTop();
                            }}
                          >
                            {data?.plans?.basic_button_text || "basic_button_text"}
                          </Button>
                        </td>
                        <td className="text-center border-bottom-0">
                          <Button
                            className="text-nowrap"
                            variant="success"
                            onClick={() => {
                              handleSubscription(monthly ? "PREMIUM_MONTH" : "PREMIUM");
                              handleClickTop();
                            }}
                          >
                            {data?.plans?.premium_button_text || "premium_button_text"}
                          </Button>
                        </td>
                        <td className="text-center border-bottom-0">
                          <CustomButton
                            className="text-nowrap"
                            variant="blue"
                            type="submit"
                            onClick={() => {
                              handleSubscription(monthly ? "PRO_MONTH" : "PRO");
                              handleClickTop();
                            }}
                          >
                            {data?.plans?.pro_button_text || "pro_button_text"}
                          </CustomButton>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              <Row>
                <Col xl={9} lg={10} className="text-center mx-auto">
                  {data.bottom_paragraph && <p className="text-center mt-md-5 mt-3">{data.bottom_paragraph}</p>}
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section whyClarity pt-lg-4 pt-2">
            <Container className="">
              <div className="">
                <h2 className="mb-3">{data?.why_title || "why_title"}</h2>
                <p className="text-xxl mb-0">{data?.why_sub_title || "why_sub_title"}</p>
              </div>

              <Row className="">
                <Col xl={10} lg={11} className="ps-xl-5">
                  <Row>
                    {data?.why_choose_clarity?.map((item) => {
                      return (
                        <Col key={item?.head} xs={12} sm={6} md={4} className="d-flex flex-column gap-2 mt-md-5 mt-4">
                          <img src={item?.image} alt="" height="50px" width="50px" className="mb-3" />
                          <p className="fw-bold mb-0">{item?.head}</p>
                          <p className="mb-0">{item?.head_label}</p>
                        </Col>
                      );
                    })}
                    <span ref={tabSectionRef} />
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          {isMobile ? (
            <Container className="program-tour-mobile pb-5">
              <h1>{data?.program_title || "program_title"}</h1>
              <p>{data?.program_sub_title || "program_sub_title"}</p>
              <Accordion defaultActiveKey="0" flush>
                <Accordion.Item className="basic" eventKey="0">
                  <Accordion.Header>Free</Accordion.Header>
                  <Accordion.Body>
                    <figure className="tabImage">
                      <img className="img-fluid" src={data?.programs?.free_section_image || TabImage} alt="" />
                    </figure>
                    <h2>{data?.programs?.free_section_title || "free_section_title"}</h2>
                    <h5>{data?.programs?.free_section_subtitle || "free_section_subtitle"}</h5>
                    <p className="mb-4 pb-4 border-bottom">{data?.programs?.free_section_paragraph || "free_section_paragraph"}. </p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.programs?.free_section_description),
                      }}
                    />
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item className="premium" eventKey="1">
                  <Accordion.Header>Premium</Accordion.Header>
                  <Accordion.Body>
                    <figure className="tabImage">
                      <img className="img-fluid" src={data?.programs?.premium_section_image || TabImage} alt="" />
                    </figure>
                    <h4 className="h6title">{data?.programs?.premium_section_title || "premium_section_title"}</h4>
                    <p className="text-xxl">{data?.programs?.premium_section_subtitle || "premium_section_subtitle"}</p>
                    <p className="dataInfo">{data?.programs?.premium_section_paragraph || "premium_section_paragraph"}. </p>
                    <hr />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.programs?.premium_section_description),
                      }}
                    />
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item className="pro" eventKey="2">
                  <Accordion.Header>Pro</Accordion.Header>
                  <Accordion.Body>
                    <figure className="tabImage">
                      <img className="img-fluid" src={data?.programs?.pro_section_image || TabImage} alt="" />
                    </figure>
                    <h4 className="h6title">{data?.programs?.pro_section_title || "pro_section_title"}</h4>
                    <p className="text-xxl">{data?.programs?.pro_section_subtitle || "pro_section_subtitle"}</p>
                    <p className="dataInfo">{data?.programs?.pro_section_paragraph || "pro_section_paragraph"}. </p>
                    <hr />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.programs?.pro_section_description),
                      }}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Container>
          ) : (
            <section className="section program-tour">
              <Container className="program-tour-inner">
                <Row className="position-relative mx-md-0">
                  <Col xl={9} lg={8} className="ms-md-auto position-static">
                    <Row className="tab-row bg-white rounded-4 mx-0">
                      <Col xl={9} lg={9} className="ms-md-auto tab-row-inner position-static ps-xxl-3 p-xl-5 p-md-5 p-sm-4 p-3">
                        <div className="mb-lg-5 mb-4">
                          <h2 className="mb-3">{data?.program_title || "program_title"}</h2>
                          <p className="text-xxl">{data?.program_sub_title || "program_sub_title"}</p>
                        </div>
                        <Tabs defaultActiveKey={key}>
                          <Tab eventKey="free" title="Free">
                            <figure className="tab-img px-5 mb-lg-0 mb-4">
                              <img className="img-fluid" src={data?.programs?.free_section_image || TabImage} alt="" />
                            </figure>
                            <h4 className="mb-2">{data?.programs?.free_section_title || "free_section_title"}</h4>
                            <p className="text-xxl mb-2">{data?.programs?.free_section_subtitle || "free_section_subtitle"}</p>
                            <p className="mb-0">{data?.programs?.free_section_paragraph || "free_section_paragraph"}. </p>
                            <hr className="my-3" />
                            <div
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(data?.programs?.free_section_description),
                              }}
                            />
                          </Tab>
                          <Tab eventKey="premium" title="Premium">
                            <figure className="tab-img px-5 mb-lg-0 mb-4">
                              <img className="img-fluid" src={data?.programs?.premium_section_image || TabImage} alt="" />
                            </figure>
                            <h4 className="mb-2">{data?.programs?.premium_section_title || "premium_section_title"}</h4>
                            <p className="text-xxl mb-2">{data?.programs?.premium_section_subtitle || "premium_section_subtitle"}</p>
                            <p className="mb-0">{data?.programs?.premium_section_paragraph || "premium_section_paragraph"}. </p>
                            <hr className="my-3" />
                            <div
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(data?.programs?.premium_section_description),
                              }}
                            />
                          </Tab>
                          <Tab eventKey="pro" title="Pro">
                            <figure className="tab-img px-5 mb-lg-0 mb-4">
                              <img className="img-fluid" src={data?.programs?.pro_section_image || TabImage} alt="" />
                            </figure>
                            <h4 className="mb-2">{data?.programs?.pro_section_title || "pro_section_title"}</h4>
                            <p className="text-xxl mb-2">{data?.programs?.pro_section_subtitle || "pro_section_subtitle"}</p>
                            <p className="mb-0">{data?.programs?.pro_section_paragraph || "pro_section_paragraph"}. </p>
                            <hr className="my-3" />
                            <div
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(data?.programs?.pro_section_description),
                              }}
                            />
                          </Tab>
                        </Tabs>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </section>
          )}

          <section className="section competitionStuck">
            <Container className="competitionInner">
              <Row className="text-center mb-5">
                <Col xl={8} lg={10} xs={12} className="mx-auto">
                  <h2 className="mb-3">{data?.offer_title || "offer_title"}</h2>
                  <p className="text-xxl">{data?.offer_sub_title || "offer_sub_title"}</p>
                </Col>
              </Row>

              <div className="table-resoponsive">
                <table widths="100%" cellPadding="0" cellSpacing="0">
                  <thead>
                    <tr>
                      <th>Feature</th>
                      <th className="text-center" width="215">
                        Clarity Cooperative
                      </th>
                      <th className="text-center" width="215">
                        Popular Private Practice Expert Website
                      </th>
                      <th className="text-center" width="215">
                        Leading Online DIY Business Course
                      </th>
                      <th className="text-center" width="215">
                        Practice Building Website
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.offer_features?.map((item) => {
                      return (
                        <tr key={item?.feature}>
                          <td>{item?.feature}</td>
                          <td className="text-center">{item?.clarity ? <i className={classes.checkedClass} aria-hidden="true" /> : ""}</td>
                          <td className="text-center">{item?.popular ? <i className={classes.checkedClass} aria-hidden="true" /> : ""}</td>
                          <td className="text-center">{item?.leading ? <i className={classes.checkedClass} aria-hidden="true" /> : ""}</td>
                          <td className="text-center">{item?.practice ? <i className={classes.checkedClass} aria-hidden="true" /> : ""}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Container>
          </section>

          <div className="memberBenefits position-relative mt-0">
            <HeroSection membershipData={data} />
          </div>

          {data?.faqs?.length > 0 && (
            <section className="faqSection section bg-white">
              <FAQSection FAQs={data?.faqs || []} title="<h1 >Frequently Asked Questions</h1>" description="" />
            </section>
          )}

          {premiumUpgradeModal && (
            <PremiumModal
              isOpen={premiumUpgradeModal}
              onClosed={() => setPremiumUpgradeModal(false)}
              title="Unlock Premium Features"
              content="Do you like what you’ve experienced so far? Unlock more potential:"
              price="$99"
              Flag="Year"
              submit={subscribeToPremium}
              submitBtn
              values={subscribeToPremium}
              monthly={monthlyPremium}
              setMonthly={setMonthlyPremium}
              couponParam={planParam === premium_year && couponParam}
              planParam={planParam === premium_year && planParam}
            />
          )}

          {premiumMonthUpgradeModal && (
            <PremiumModal
              isOpen={premiumMonthUpgradeModal}
              onClosed={() => setPremiumMonthUpgradeModal(false)}
              title="Unlock Premium Features"
              content="Do you like what you’ve experienced so far? Unlock more potential:"
              price="$9.99"
              Flag="Month"
              submit={subscribeToPremiumMonth}
              submitBtn
              values={subscribeToPremiumMonth}
              monthly={monthlyPremium}
              setMonthly={setMonthlyPremium}
              couponParam={planParam === premium_month && couponParam}
              planParam={planParam === premium_month && planParam}
            />
          )}

          {proUpgradeModal && (
            <ProModal
              isOpen={proUpgradeModal}
              onClosed={() => setProUpgradeModal(false)}
              title="Unlock Pro Features"
              content="Do you like what you’ve experienced so far? Unlock more potential:"
              price="$199"
              Flag="Year"
              submit={subscribeToPro}
              submitBtn
              values={subscribeToPro}
              isFreeTrial={false}
              monthly={monthlyPro}
              setMonthly={setMonthlyPro}
              couponParam={planParam === pro_year && couponParam}
              planParam={planParam === pro_year && planParam}
            />
          )}

          {proMonthUpgradeModal && (
            <ProModal
              isOpen={proMonthUpgradeModal}
              onClosed={() => setProMonthUpgradeModal(false)}
              title="Unlock Pro Features"
              content="Do you like what you’ve experienced so far? Unlock more potential:"
              price="$19.99"
              Flag="Month"
              submit={subscribeToProMonth}
              submitBtn
              values={subscribeToProMonth}
              isFreeTrial={false}
              monthly={monthlyPro}
              setMonthly={setMonthlyPro}
              couponParam={planParam === pro_month && couponParam}
              planParam={planParam === pro_month && planParam}
            />
          )}
          {freeTrialProModal && (
            <ProModal
              isOpen={freeTrialProModal}
              onClosed={() => setFreeTrialProModal(false)}
              title="Unlock Pro Features"
              content="Do you like what you’ve experienced so far? Unlock more potential:"
              price=""
              Flag=""
              submit=""
              submitBtn
              values=""
              isFreeTrial
              monthly={monthlyPro}
              setMonthly={setMonthlyPro}
            />
          )}
          {basic1Model && (
            <PlanToBasicModel isOpen={basic1Model} onClosed={() => setBasic1Modal(false)} message="Are you sure you want to cancel the current subscription?" />
          )}
          <SignupModal show={isModal} onHide={() => setIsModal(false)} />
          <FooterBottom />
        </>
      )}
    </>
  );
}

export default withRouter(Membership);
